export const BOARD_VIEW_MODS = {
  LARGE: "large",
  MEDIUM: "medium",
  SMALL: "small"
};
